import { CALL_INTAKE_API } from 'middleware/intakeApi';
import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

import {
  GET_RELOCATION_CONSULTANTS_FAILURE,
  GET_RELOCATION_CONSULTANTS_REQUEST,
  GET_RELOCATION_CONSULTANTS_SUCCESS,
  GET_SEARCH_RESULTS_FAILURE,
  GET_SEARCH_RESULTS_REQUEST,
  GET_SEARCH_RESULTS_SUCCESS,
  GET_INTERNAL_USERS_REQUEST,
  GET_INTERNAL_USERS_SUCCESS,
  GET_INTERNAL_USERS_FAILURE,
  POST_INTERNAL_USER_REQUEST,
  POST_INTERNAL_USER_SUCCESS,
  POST_INTERNAL_USER_FAILURE,
  PUT_INTERNAL_USER_REQUEST,
  PUT_INTERNAL_USER_SUCCESS,
  PUT_INTERNAL_USER_FAILURE,
  DELETE_INTERNAL_USER_REQUEST,
  DELETE_INTERNAL_USER_SUCCESS,
  DELETE_INTERNAL_USER_FAILURE,
  GET_VENDORS_FAILURE,
  POST_VENDOR_REQUEST,
  POST_VENDOR_SUCCESS,
  POST_VENDOR_FAILURE,
  GET_VENDORS_REQUEST,
  GET_VENDORS_SUCCESS,
  PUT_VENDOR_REQUEST,
  PUT_VENDOR_SUCCESS,
  PUT_VENDOR_FAILURE,
  DELETE_VENDOR_REQUEST,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_FAILURE,
  GET_AGENTS_REQUEST,
  GET_AGENTS_SUCCESS,
  GET_AGENTS_FAILURE,
  POST_AGENT_REQUEST,
  POST_AGENT_SUCCESS,
  POST_AGENT_FAILURE,
  PUT_AGENT_REQUEST,
  PUT_AGENT_SUCCESS,
  PUT_AGENT_FAILURE,
  DELETE_AGENT_REQUEST,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAILURE
} from './store/types';

export const getRelocationConsultants = () => {
  return {
    [CALL_INTAKE_API]: {
      types: [GET_RELOCATION_CONSULTANTS_REQUEST, GET_RELOCATION_CONSULTANTS_SUCCESS, GET_RELOCATION_CONSULTANTS_FAILURE],
      authenticated: true,
      endpoint: 'relocationConsultants',
      method: 'GET'
    }
  };
};

export const getSearchResults = searchTerm => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_SEARCH_RESULTS_REQUEST, GET_SEARCH_RESULTS_SUCCESS, GET_SEARCH_RESULTS_FAILURE],
      authenticated: true,
      endpoint: `api/ClientPolicys/search/${searchTerm}`,
      method: 'GET'
    }
  };
};

export const getInternalUsers = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_INTERNAL_USERS_REQUEST, GET_INTERNAL_USERS_SUCCESS, GET_INTERNAL_USERS_FAILURE],
      authenticated: true,
      endpoint: 'api/common/internalUsers',
      method: 'GET'
    }
  };
};

export const postInternalUser = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_INTERNAL_USER_REQUEST, POST_INTERNAL_USER_SUCCESS, POST_INTERNAL_USER_FAILURE],
      authenticated: true,
      endpoint: 'api/common/internalUsers',
      method: 'POST',
      payload: values
    }
  };
};

export const putInternalUsers = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_INTERNAL_USER_REQUEST, PUT_INTERNAL_USER_SUCCESS, PUT_INTERNAL_USER_FAILURE],
      authenticated: true,
      endpoint: 'api/common/internalUsers',
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteInternalUser = internalUserId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_INTERNAL_USER_REQUEST, DELETE_INTERNAL_USER_SUCCESS, DELETE_INTERNAL_USER_FAILURE],
      authenticated: true,
      endpoint: `api/common/internalUsers/${internalUserId}`,
      method: 'DELETE'
    }
  };
};

export const getVendors = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_VENDORS_REQUEST, GET_VENDORS_SUCCESS, GET_VENDORS_FAILURE],
      authenticated: true,
      endpoint: 'api/vendors',
      method: 'GET'
    }
  };
};

export const postVendor = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VENDOR_REQUEST, POST_VENDOR_SUCCESS, POST_VENDOR_FAILURE],
      authenticated: true,
      endpoint: 'api/vendors',
      method: 'POST',
      payload: values
    }
  };
};

export const putVendor = (vendorId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_VENDOR_REQUEST, PUT_VENDOR_SUCCESS, PUT_VENDOR_FAILURE],
      authenticated: true,
      endpoint: `api/vendors/${vendorId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteVendor = vendorId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_VENDOR_REQUEST, DELETE_VENDOR_SUCCESS, DELETE_VENDOR_FAILURE],
      authenticated: true,
      endpoint: `api/vendors/${vendorId}`,
      method: 'DELETE'
    }
  };
};

export const getAgents = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_AGENTS_REQUEST, GET_AGENTS_SUCCESS, GET_AGENTS_FAILURE],
      authenticated: true,
      endpoint: 'api/common/agents',
      method: 'GET'
    }
  };
};

export const postAgent = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AGENT_REQUEST, POST_AGENT_SUCCESS, POST_AGENT_FAILURE],
      authenticated: true,
      endpoint: 'api/common/agents',
      method: 'POST',
      payload: values
    }
  };
};

export const putAgent = (agentId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_AGENT_REQUEST, PUT_AGENT_SUCCESS, PUT_AGENT_FAILURE],
      authenticated: true,
      endpoint: `api/common/agents/${agentId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteAgent = agentId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_AGENT_REQUEST, DELETE_AGENT_SUCCESS, DELETE_AGENT_FAILURE],
      authenticated: true,
      endpoint: `api/common/agents/${agentId}`,
      method: 'DELETE'
    }
  };
};
